export const createOrderedChunkBuffer = ({ onReady, onDuplicate, onStale }) => {
  let expectedSequence = 0;
  let activeTurnId = null;
  const buffered = new Map();

  const reset = (turnId) => {
    buffered.forEach((chunk) => chunk.url && URL.revokeObjectURL(chunk.url));
    buffered.clear();
    expectedSequence = 0;
    activeTurnId = turnId;
  };

  const add = (chunk) => {
    if (chunk.turnId !== activeTurnId) {
      onStale?.(chunk);
      chunk.url && URL.revokeObjectURL(chunk.url);
      return;
    }
    if (chunk.sequence < expectedSequence || buffered.has(chunk.sequence)) {
      onDuplicate?.(chunk);
      chunk.url && URL.revokeObjectURL(chunk.url);
      return;
    }
    buffered.set(chunk.sequence, chunk);
    while (buffered.has(expectedSequence)) {
      const next = buffered.get(expectedSequence);
      buffered.delete(expectedSequence);
      onReady(next);
      expectedSequence += 1;
    }
  };

  return {
    add,
    reset,
    getSnapshot: () => ({ activeTurnId, expectedSequence, bufferedSequences: [...buffered.keys()].sort((a, b) => a - b) }),
  };
};
